import PropTypes from 'prop-types';
import React from 'react';
import PhaseType from 'types/phase';

export const rocky = ({ event: { kind, data = {} } }) =>
  <div className={kind}>
    {data.placeholder
      ? 'Rocky placeholder: phase would be sent to Lowe\'s Rocky'
      : 'Phase information sent to Rocky'}
  </div>;

rocky.propTypes = {
  event: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    data: PropTypes.shape({
      placeholder: PropTypes.bool,
    }),
  }).isRequired,
  phase: PhaseType,
};



// WEBPACK FOOTER //
// ./client/app/shared/components/PhaseHistoryCard/phaseEvents/rocky.jsx